import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
} from "@mui/material";
import "./SFGstore.css";
import COCDatePicker from "../../components/DateTimePicker/DateTimePicker";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import { getSFGStoreDetails, printAgainSFGBoxLabel } from "./services";
import { images } from "../../config/images";
import Button from "../../components/Button/Button";
import { toast, ToastContainer } from "react-toastify";

const SFGHistory = () => {
  const data = [
    { class: "00", size: 3, length: 380, type: "SC", quantity: 825 },
    { class: "1", size: 9, length: 420, type: "RE", quantity: 760 },
    { class: "2", size: 10, length: 380, type: "SC", quantity: 825 },
    { class: "3", size: 11, length: 420, type: "RE", quantity: 760 },
  ];

  const navigate = useNavigate();
  const [showTime, setShowTime] = useState(false);
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [SFGStoreDetails, setSFGStoreDetails] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [printdisable, setPrintdisable] = useState(false);
  const [printAgainStatus, setPrintAgainstatus] = useState(false);
  const [boxId, setBoxId] = useState("");
  const [printer, setPrinter] = useState("");
  const handleToggleTime = () => {
    setShowTime(!showTime);
  };
  const handleStartDate = (newStartDate) => {
    if (showTime) {
      setStartDateReFormat(newStartDate);
    } else {
      setStartDateReFormat(dayjs(newStartDate).hour(23).minute(59).second(0));
    }
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
    }
  };

  const initiallValue = {
    Date: "",
    batch__batch_type: "",
    aging: "",
    box_no: "",
    class_id__class_name: "",
    lot_no: "",
    cuff: "",
    size__size_name: "",
    length__length: "",
    scre_type: "",
    quantity: "",
    packed_by: "",
    prints: "",
    label_no:""
  };

  const [searchText, setSearchText] = useState(initiallValue);
  const [isPrinting, setisPrinting] = useState(false);
  const [isPrintingDone, setisPrintingDone] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes

  const handlePrintagain = async (id, printer) => {
    setBoxId(id);
    setPrinter(printer);
    PrintAgainBoxLabelAPI(id, printer);
  };
  const handleSearchData = async (e) => {
    // Destructure the name and value of the input field that triggered the change
    const { name, value } = e.target;

    // Update the searchText state object with the new value for the specified input field
    setSearchText({ ...searchText, [name]: value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const dateFormat = "YYYY-MM-DD";
  const TimeFormat = "YYYY-MM-DD HH:mm:ss";
  const formatStartDate = startDateReFormat
    ? dayjs(startDateReFormat).format(dateFormat)
    : "";
  const formatEndDate = endDateReFormat
    ? dayjs(endDateReFormat).format(dateFormat)
    : "";

  const formatStartDateTime = startDateReFormat
    ? dayjs(startDateReFormat).format(TimeFormat)
    : "";
  const formatEndDateTime = endDateReFormat
    ? dayjs(endDateReFormat).format(TimeFormat)
    : "";
  const fetchData = async () => {
    const searchParams = {
      search: debouncedSearchText,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    if (startDateReFormat && endDateReFormat) {
      if (showTime) {
        searchParams.start_datetime = formatStartDateTime;
        searchParams.end_datetime = formatEndDateTime;
      } else {
        searchParams.start_datetime = `${formatStartDate} 00:00:00`;
        searchParams.end_datetime = `${formatEndDate} 23:59:59`;
      }
    }
    try {
      const response = await getSFGStoreDetails(searchParams);
      if (response.data.success == true) {
        setSFGStoreDetails(response.data.payload);
        setTotalCount(response.data.total_quantity);
      }
    } catch (error) {
      setSFGStoreDetails([]);
      console.log(error);
    }
  };

  useEffect(() => {
    if (Object.keys(debouncedSearchText).length > 0) {
      fetchData();
    }
  }, [
    debouncedSearchText,
    page,
    rowsPerPage,
    formatStartDate,
    formatEndDate,
    showTime,
  ]);
  const handleRemoveStorage = async () => {
    setisPrintingDone(false);
  };
  const PrintAgainBoxLabelAPI = async (id, printer) => {
    setisPrinting(true);
    setPrintAgainstatus(false);
    const parms = {
      sfg_box_id: id,
      printer:
        printer == "Printer 3"
          ? "Printer 3"
          : printer == "Printer 2"
          ? "Printer 2"
          : printer == "Printer 1"
          ? "Printer 1"
          : null,
    };

    // setPrintdisable(true);
    try {
      const PrintBox = await printAgainSFGBoxLabel(parms);
      setisPrinting(false);
      setisPrintingDone(true);
      setPrintdisable(true);
      if (PrintBox.status === 200 || PrintBox.status === 201) {
        setPrintdisable(false);
        toast.success(PrintBox.data.message);
      }
    } catch (e) {
      toast.error(e.response.data.message);
      setisPrinting(false);
      setPrintdisable(false);
    }
  };
  const NoPrintHandle = () => {
    setisPrintingDone(false);
    setPrintAgainstatus(true);
  };
  return (
    <>
      <ToastContainer />
      <div className="dashboard-wrapper page-wraper">
        <div className="page-header">
          <div
            className="page-back-btn"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
            <span>SFG History</span>
          </div>
          <div className="d-flex">
            <h4 className="d-flex mt-3" style={{ fontWeight: 400 }}>
              Total <b style={{ marginLeft: "10px" }}>{totalCount}</b>
            </h4>
            <FormGroup aria-label="position" row>
              <FormControlLabel
                className="time-picker"
                value="top"
                control={<Switch color="primary" checked={showTime} />}
                label="Time"
                labelPlacement="top"
                onChange={handleToggleTime}
              />
            </FormGroup>

            <COCDatePicker
              time={showTime}
              startDateReFormat={startDateReFormat}
              endDateReFormat={endDateReFormat}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              Start_Date_lable={"Start Date"}
              end_Date_lable={"End Date"}
            />
          </div>
        </div>
        <div className="pt-3 table-responsive">
          <TableContainer component={Paper}>
            <Table
              aria-label="Dipping parameter"
              className="dipping-params sfg-score-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Date and Time</TableCell>
                  <TableCell>Label No.</TableCell>
                  <TableCell>Box No.</TableCell>
                  <TableCell>No.of Prints</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>LOT No.</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Cuff</TableCell>
                  <TableCell>Length</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Packed By</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Date and Time"
                      name="Date"
                      value={searchText.Date}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                 
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Label No."
                      name="box_no"
                      value={searchText.box_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Box No."
                      name="label_no"
                      value={searchText.label_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="No.of Prints"
                      name="prints"
                      value={searchText.prints}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Class"
                      name="class_id__class_name"
                      value={searchText.class_id__class_name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Lot No"
                      name="lot_no"
                      value={searchText.lot_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Size"
                      name="size__size_name"
                      value={searchText.size__size_name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Cuff"
                      name="cuff"
                      value={searchText.cuff}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Length"
                      name="length__length"
                      value={searchText.length__length}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Type"
                      name="scre_type"
                      value={searchText.scre_type}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Quantity"
                      name="quantity"
                      value={searchText.quantity}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Packed By"
                      name="packed_by"
                      value={searchText.packed_by}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {SFGStoreDetails?.results?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {" "}
                      {dayjs(row.created_at).format("YYYY-MM-DD HH:mm")}
                    </TableCell>
                   
                    <TableCell className="box-no-print-status">
                      {row.box_no}
                      <button
                        className={"page-header-button printer-icon"}
                        onClick={() => {
                          handlePrintagain(row.box_id, row.printer);
                        }}
                      >
                        {" "}
                        <img
                          src={images.printIcon}
                          className={row.is_printed ? "" : ""}
                        />
                      </button>
                    </TableCell>
                    <TableCell>{row.sfg_label}</TableCell>
                    <TableCell>{row.no_of_prints}</TableCell>
                    <TableCell>{row.class_name}</TableCell>
                    <TableCell>{row.lot_no}</TableCell>
                    <TableCell>{row.size_name}</TableCell>
                    <TableCell>{row.cuff}</TableCell>
                    <TableCell>{row.length_name}</TableCell>
                    <TableCell>{row.scre_type}</TableCell>
                    <TableCell>{row.quantity}</TableCell>
                    <TableCell>{row.created_by}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={SFGStoreDetails ? SFGStoreDetails.count : null}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {isPrinting ? (
          <>
            <div className="sendingdatasimple-pop-up">
              <Card className="pairingcard-Approved-simple-pop-up">
                <CardContent className="p-0 pairing-status">
                  <h4>{"Printing....."}</h4>
                </CardContent>
              </Card>
            </div>
          </>
        ) : null}
        {isPrintingDone ? (
          <>
            <div className="sendingdataaaa1">
              <Card className="pairingcard-Approved">
                <CardContent className="p-0 pairing-status">
                  <h4>Printed</h4>
                </CardContent>
                <Button
                  className="pairingcard-btn"
                  title="Yes"
                  onClick={() => handleRemoveStorage()}
                />
                <Button
                  className="pairingcard-btn"
                  title="No"
                  onClick={() => {
                    NoPrintHandle();
                  }}
                />
              </Card>
            </div>
          </>
        ) : null}
        {printAgainStatus ? (
          <>
            <div className="sendingdataaaa1">
              <Card className="pairingcard-Approved">
                <CardContent className="p-0 pairing-status">
                  <h4>Print Again?</h4>
                </CardContent>
                <Button
                  className="pairingcard-btn"
                  title="Yes"
                  onClick={() => handlePrintagain(boxId, printer)}
                />
                <Button
                  className="pairingcard-btn"
                  title="No"
                  onClick={() => {
                    window.location.reload();
                  }}
                />
              </Card>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default SFGHistory;
